import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as message from '../message'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: message.RESOURCE.payload.dimension.partialId,
      partialId: message.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The role of the message sender (user or agent)',
    isOptional: false,
    name: 'Role',
    partialId: PartialId.Standard.create('role'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.messageRole.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
